import styled from "@emotion/styled"
import type { IconName } from "@porsche-design-system/components-react"
import { PHeading, PIcon, PText } from "@porsche-design-system/components-react"
import { spacingStaticMd } from "@porsche-design-system/components-react/emotion"

interface InformationProps {
	icon?: IconName
	text: string
	title: string
}

export const Information = ({ icon, text, title }: InformationProps) => {
	return (
		<Error>
			<StyledIcon name={icon ?? "warning"} size="lg" />
			<StyledHeading align="center" size="lg" tag="h4">
				{title}
			</StyledHeading>
			<PText align="center" size="sm">
				{text}
			</PText>
		</Error>
	)
}

const Error = styled.div`
	height: 100%;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`

const StyledIcon = styled(PIcon)`
	margin-bottom: ${spacingStaticMd};
`

const StyledHeading = styled(PHeading)`
	margin-bottom: ${spacingStaticMd};
`
